import {
    DEFAULT_DESTINATION_EXPANSIONS,
    DestinationEvent,
} from '@eventbrite/event-renderer';
import { sdkRequest } from '@eventbrite/http';

export type EventExpansionsApiResponse = { events: DestinationEvent[] };

export const DEFAULT_EXPANSIONS = [
    'event_sales_status',
    'image',
    'primary_venue',
    'saves',
    'ticket_availability',
    'primary_organizer',
    'public_collections',
];

const DESTINATION_EVENTS_ENDPOINT = '/api/v3/destination/events/';

export const fetchEventExpansions = (
    eventIds: string[] = [],
    expansions = DEFAULT_DESTINATION_EXPANSIONS,
) => {
    const eventIdsJoined = eventIds.join(',');

    return sdkRequest(
        `${DESTINATION_EVENTS_ENDPOINT}?event_ids=${eventIdsJoined}&page_size=${eventIds.length}&expand=${expansions}`,
    );
};

export const fetchSearchEventExpansions = (
    eventIds: string[],
): Promise<EventExpansionsApiResponse> => {
    return fetchEventExpansions(eventIds, DEFAULT_EXPANSIONS);
};

export const fetchEventUrgencySignals = (
    eventIds: string[],
): Promise<EventExpansionsApiResponse> => {
    const eventIdsJoined = eventIds.join(',');

    return sdkRequest(
        `${DESTINATION_EVENTS_ENDPOINT}?event_ids=${eventIdsJoined}&page_size=${eventIds.length}&expand=urgency_signals`,
    );
};
